import { TOptions } from 'i18next';
import { useTranslation as useTranslationHook } from 'react-i18next';

import { Translations } from './i18n';

export interface TranslationFunction {
  // basic usage
  (key: Translations, options?: TOptions<{ [key: string]: any }> | string): string;
  // overloaded usage
  (key: Translations, defaultValue?: string, options?: TOptions<{ [key: string]: any }> | string): string;
}

const useTranslation = () => {
  const { t } = useTranslationHook();
  return t as TranslationFunction;
};

export default useTranslation;
